<style lang="less" scoped>

</style>

<template lang="pug">
  #order.admin-container
    .admin-title-cover
      .admin-title 주문 내역
    .admin-content-cover
      .order-list-cover
        el-table(
          :data="orders"
          style="width: 100%")
          el-table-column(
            label="상태",
            width="80")
            template(slot-scope="scope")
              router-link(:to="`/admin/order/${scope.row._id}`")
                div {{statusToString(scope.row.status)}}
          el-table-column(
            prop="created"
            label="날짜"
            width="150")
            template(slot-scope='scope') {{ scope.row.created | date }}
          el-table-column(
            prop="user.name"
            label="주문자"
            width="80")
          el-table-column(
            prop="name"
            label="받는사람"
            width="80")
          el-table-column(
            prop="address"
            label="주소")
          el-table-column(label="처방내용")
            template(slot-scope='scope')
              div {{scope.row.prescriptions[0].name}}

</template>

<script>
import happytree from '@/happytree';
import moment from 'moment';

export default {
  data() {
    return {
      orders: null,
    };
  },
  methods: {
    statusToString(status) {
      let result = null;
      switch (status) {
        case happytree.status.pending:
          result = '접수대기';
          break;

        case happytree.status.paid:
          result = '지불';
          break;

        case happytree.status.sent:
          result = '발송완료';
          break;

        case happytree.status.canceled:
          result = '취소';
          break;

        default:
          result = '조제중';
          break;
      }
      return result;
    },
  },
  filters: {
    date(value) {
      const encoded = moment(value);
      if (encoded.isValid()) {
        return encoded.format('LL');
      }
      return value;
    },
  },
  async mounted() {
    const { data } = await this.$http.get('/orders');
    this.orders = data;
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/order.vue